import { render, staticRenderFns } from "./cyapss-introduction.component.vue?vue&type=template&id=2ca96d1a"
import script from "./cyapss-introduction.component?vue&type=script&lang=ts&external"
export * from "./cyapss-introduction.component?vue&type=script&lang=ts&external"
import style0 from "./cyapss-introduction.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports